import styles from './PrivacyPolicy.module.css';

export default function PrivacyPolicy() {
  return (
    <div className={styles.container}>
      <div className={styles.overlay} />
      <div className={styles.content}>
        <h1 className={styles.title}>Privacy Policy</h1>
        <div className={styles.policyContent}>
          <section className={styles.section}>
            <h2>Our Commitment to Privacy</h2>
            <p>
              At MyPeopleDatabase, we take your privacy seriously. Our core principle is simple:
              <strong> No data collection, maximum privacy protection</strong>.
            </p>
          </section>

          <section className={styles.section}>
            <h2>No Data Collection Policy</h2>
            <p>
              We do not collect, store, or process any personal information from visitors to our
              website. Our website is designed to be completely data-collection free, which means:
            </p>
            <ul>
              <li>No cookies are used for tracking or analytics</li>
              <li>No personal information is stored during your visit</li>
              <li>No user behavior is monitored or analyzed</li>
              <li>No data is shared with third parties</li>
            </ul>
          </section>

          <section className={styles.section}>
            <h2>Affiliate Program Data Collection</h2>
            <p>
              While we maintain a no-data-collection policy for website visitors, our affiliate
              program operates separately and requires limited data collection for program
              participants:
            </p>
            <ul>
              <li>
                <strong>Affiliate Registration:</strong> Email address and payment information for
                commission processing
              </li>
              <li>
                <strong>Commission Tracking:</strong> Purchase referrals and commission calculations
              </li>
              <li>
                <strong>Payment Processing:</strong> Information necessary to send affiliate
                payments
              </li>
              <li>
                <strong>Communication:</strong> Email notifications about sales and commission
                updates
              </li>
            </ul>
            <p>
              Affiliate data is used solely for program administration and commission payments. We
              do not share affiliate information with third parties except as necessary for payment
              processing. Affiliates may opt out of the program at any time by contacting us.
            </p>
          </section>

          <section className={styles.section}>
            <h2>Your Privacy Is Protected</h2>
            <p>
              Since we don't collect any data, your privacy is inherently protected when using our
              website. You can browse our site with the confidence that your online activities
              remain private and are not being tracked or recorded.
            </p>
          </section>

          <section className={styles.section}>
            <h2>Contact Information</h2>
            <p>
              If you have any questions about this Privacy Policy, please contact us through our
              website.
            </p>
          </section>

          <section className={styles.section}>
            <h2>Policy Updates</h2>
            <p>This Privacy Policy was last updated on July 10, 2025.</p>
          </section>
        </div>
      </div>
    </div>
  );
}
